import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { CustomerService } from '../admin/pages/customers/customerService';

// ─────────────────────────────────────────────────────────────────────────────
// QUERY KEYS
// ─────────────────────────────────────────────────────────────────────────────
export const CUSTOMER_KEYS = {
  all: ['customers'] as const,
};

// ─────────────────────────────────────────────────────────────────────────────
// useCustomers
// ─────────────────────────────────────────────────────────────────────────────
export const useCustomers = () => {
  return useQuery({
    queryKey: CUSTOMER_KEYS.all,
    queryFn: () => CustomerService.getAllCustomers(),
    staleTime: 1000 * 60 * 2,
    retry: (failureCount, error: any) => {
      if (error?.message?.includes('permission')) return false;
      return failureCount < 2;
    },
  });
};

// ─────────────────────────────────────────────────────────────────────────────
// useCustomerMutations
// ─────────────────────────────────────────────────────────────────────────────
export const useCustomerMutations = () => {
  const queryClient = useQueryClient();

  const toggleStatus = useMutation({
    mutationFn: ({ uid, isActive }: { uid: string; isActive: boolean }) =>
      CustomerService.toggleCustomerStatus(uid, isActive),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: CUSTOMER_KEYS.all }),
  });

  return { toggleStatus };
};
